import React from 'react';
import dayjs from 'dayjs';
import { Typography, Grid, Divider } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const PlanSponsorTitleCard = ({
  isLoading,
  planName,
  provider,
  status,
  contractDate,
}) => {
  return (
    <>
      <Grid container style={{ marginBottom: 16 }}>
        <Grid item>
          {!isLoading ? (
            <Typography variant="h4" color="textPrimary">
              {planName}
            </Typography>
          ) : (
            <Skeleton variant="text" height={45} width={865} />
          )}
        </Grid>
      </Grid>
      <Grid container style={{ marginBottom: 8 }}>
        <Grid item>
          {!isLoading ? (
            <Typography variant="h6" color="textPrimary">
              Provider: {provider ?? 'N/A'}
            </Typography>
          ) : (
            <Skeleton variant="text" height={40} width={400} />
          )}
        </Grid>
        <Divider
          flexItem
          orientation="vertical"
          style={{ borderRightWidth: 3, marginLeft: 32, marginRight: 32 }}
        />
        <Grid item>
          {!isLoading ? (
            <Typography variant="h6" color="textPrimary">
              Status: {status ?? 'N/A'}
            </Typography>
          ) : (
            <Skeleton variant="text" height={40} width={400} />
          )}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          {!isLoading ? (
            <Typography variant="subtitle1" color="textPrimary">
              Contract Date:{' '}
              {contractDate == null
                ? 'N/A'
                : dayjs(contractDate).format('MM-DD-YYYY')}
            </Typography>
          ) : (
            <Skeleton variant="text" height={40} width={400} />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default PlanSponsorTitleCard;
